export default __webpack_public_path__ + "static/what-to-do-in-japan-timing-it-right-1991f66250183882a21ef56f16ad7c30.jpg";